import React from "react";
import { HealthStreamLogo } from "components/Images";
import ComingSoonImg from "components/Images/comingsoon.png";

const Maintenance = () => {
  return (
    <>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html:
            ".site {padding: 0} .site__header, .site__footer { display: none; }"
        }}
      />
      <div className="comingsoon">
        <div className="header">
          <HealthStreamLogo
            className="site__header-logo"
            alt="Logo: HealthStream"
          />
        </div>
        <div className="body">
          <div>
            <img src={ComingSoonImg} alt="" />
            <div>
              <h1>Under Maintenance</h1>
              <h3>
                The online store is currently down for maintenance. We expect to
                be back soon. Thank you for your patience.
              </h3>
              <p>
                In the meantime, check out the other solutions&nbsp;
                <a href="https://www.healthstream.com/">HealthStream</a>
                &nbsp;has to offer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Maintenance;
